import { Component, OnInit, Inject, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '../../../core/services/header/header.service';
import * as _ from 'lodash';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { LoaderService } from '../../../shared/services/loader/loader.service';
import { UserService } from 'src/app/core/services/user-service/user-service.service';
import { userRoleAccessCustCustomerUser, userRoleAccessStudioWBSOUser } from '../../../../assets/constants/userRole';
import { ToastService } from '../../../shared/services/toast-service/toast.service';
import { EMAIL_TEMPLATE_ROUTE } from '../../../shared/constants/common';
import { HOMEPAGE_CONSTANTS } from '../../constants/core.constant';
import { BaseApiService } from 'src/app/shared/services/base-api/base-api.service';

@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
    standalone: false
})
export class HomepageComponent implements OnInit {
  userInfoEmitter = new EventEmitter<any>();
  isLoggedIn: any;
  loading: boolean = true;
  overlayState: boolean = false;
  @ViewChild('successTpl', { static: false }) successTpl!: TemplateRef<any>;
  @ViewChild('dangerTpl', { static: false }) dangerTpl!: TemplateRef<any>;
  addUserError: any;
  addUserSuccess: any;
  clearCache: any;
  userClaims: any;
  isToastrTokenTimeoutDisplayed: any;
  sessionTimeoutWarning: any;
  sessionTimeoutWarningOneMin: any;
  sessionTimeout: any;
  email_route = EMAIL_TEMPLATE_ROUTE;
  constants = HOMEPAGE_CONSTANTS;

  constructor(
    public headerService: HeaderService,
    public router: Router,
    public userService: UserService,
    @Inject(OKTA_AUTH) public _oktaAuth: OktaAuth,
    public _oktaStateService: OktaAuthStateService,
    public loaderService: LoaderService,
    public toastService: ToastService,
    private readonly baseService: BaseApiService
  ) {
    this.isAuthenticated();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    this.loaderService.overlayState$.subscribe((applying) => {
      this.overlayState = applying;
    });

    // Subscribe to Okta auth state changes
    this._oktaStateService.authState$.subscribe(async (authState) => {
      if (authState.isAuthenticated) {
        // Wait for tokens to be processed and user-profile to be set
        let userProfile = localStorage.getItem('user-profile');
        if (!userProfile) {
          // Fetch user profile if not present
          await this.getAuthenticate();
          userProfile = localStorage.getItem('user-profile');
        }
        if (userProfile) {
          this.redirectToDashboard(JSON.parse(userProfile));
        }
      }
    });
  }

  /**
   *checkAuthentication() - checkAuthentication method is to clear the okta token completely from localstorage after user in logged out.
   */
  async checkAuthentication(): Promise<void> {
    if (!this.isLoggedIn) {
      this._oktaAuth.tokenManager.clear();
    }
  }

  /**
   * isAuthenticated() - isAuthenticated is to check the user is logged in or not in the application.
   */
  async isAuthenticated(): Promise<void> {
    this.isLoggedIn = await this._oktaAuth.isAuthenticated();
  }

  /**
   * getAuthenticate() - getAuthenticate method authenticate the first api in the application.
   */
  async getAuthenticate(): Promise<any> {
    this.loaderService.setLoadingState(true);
    await this.headerService.getauth().subscribe(
      {
        next: (value: any) => {
          const userProfile = JSON.parse(localStorage.getItem('user-profile'));
          if (_.isNil(userProfile)) {
            this.getuserInfo(value?.emailAddress);
            this.populateUsernameAndQuickSearch();
          }
          return value
        },
        error: (error: any) => {
          this.loaderService.setLoadingState(false)
          this.addUserError = error;
          this.showDanger(this.dangerTpl);
          setTimeout(() => {
            this.logout();
          }, 3000);
        }
      }
    )
  }

  /**
   *getuserInfo() - getuserInfo method gives the logged in user profile information.
   */
  async getuserInfo(userEmail: string): Promise<any> {
    const user_okta = (localStorage.getItem('okta-token-storage'));
    if (user_okta) {
        await this.headerService.getuserinfo(userEmail).subscribe((data: any) => {
        let roleAssigned: any = [];
        let permissionsData: any = {};
        roleAssigned = data.userProfileDTO.roles;
        let portalType = data.userProfileDTO.portalType;
        if (data.userProfileDTO.userTypeId == 1) {
          let type = 'customer';
          if (portalType.some(item => item.includes(type))) {
            //logic written for customer portal customer user 
            Object.keys(userRoleAccessCustCustomerUser).forEach((menuItem: any) => {
              permissionsData[menuItem] = userRoleAccessCustCustomerUser[menuItem]?.some((role: any) => {
                return roleAssigned.includes(role)
              })
            })
          }
          // commented to test the user role changes in dev
          // else {
          //   //logic written for customer portal studio user 
          //   Object.keys(userRoleAccessCustStudioUser).forEach((menuItem: any) => {
          //     permissionsData[menuItem] = userRoleAccessCustStudioUser[menuItem]?.some((role: any) => {
          //       return roleAssigned.includes(role)
          //     })
          //   })
          // }

        } else if (data.userProfileDTO.userTypeId == 2) {
          //logic written for studio portal wbso user 
          Object.keys(userRoleAccessStudioWBSOUser).forEach((menuItem: any) => {
            permissionsData[menuItem] = userRoleAccessStudioWBSOUser[menuItem]?.some((role: any) => {
              return roleAssigned.includes(role)
            })
          })
        }

        data.userProfileDTO.roleAssigned = permissionsData;
        localStorage.setItem('user-profile', JSON.stringify(data.userProfileDTO));
        const userProfile = JSON.parse(localStorage.getItem('user-profile'));
        this.userService.setUserInfo(data);
        // Always redirect after fetching profile
        this.redirectToDashboard(userProfile);

        if (localStorage.getItem('okta-token-storage')) {
          if (
            JSON.parse(localStorage.getItem('okta-token-storage')!).accessToken !==
            undefined
          ) {
            if (
              JSON.parse(localStorage.getItem('okta-token-storage')!).accessToken
                .accessToken !== undefined
            ) {
              if (
                JSON.parse(localStorage.getItem('okta-token-storage')!).accessToken
                  .accessToken.length > 0
              ) {
                this.populateUsernameAndQuickSearch();
              }
            }
          }
        }
      },
        (error) => {
          this.loaderService.setLoadingState(false);
          this.addUserError = error;
          this.showDanger(this.dangerTpl);
          console.error(error);
        }
      )
    }
  }

  /**
   * getSecondsUntilAccessTokenExpires() - invoking the timer for the session for the logged in user.
   */
  getSecondsUntilAccessTokenExpires(): any {
    let expiresAt;
    let numberOfSecondsUntilAccessTokenExpires;
    if (localStorage.getItem('okta-token-storage')) {
      if (
        JSON.parse(localStorage.getItem('okta-token-storage')!).accessToken !==
        undefined
      ) {
        if (
          JSON.parse(localStorage.getItem('okta-token-storage')!).accessToken
            .expiresAt !== undefined
        ) {
          expiresAt = JSON.parse(localStorage.getItem('okta-token-storage')!)
            .accessToken.expiresAt;
        }
      }
    }
    const now = new Date();
    const currentEpochTime = Math.round(now.getTime() / 1000);
    const buffer = 60;
    if (expiresAt && expiresAt > 0) {
      numberOfSecondsUntilAccessTokenExpires =
        expiresAt - currentEpochTime - buffer;
    } else {
      numberOfSecondsUntilAccessTokenExpires = 0;
    }
    return numberOfSecondsUntilAccessTokenExpires;
  }

  /**
   * populateUsernameAndQuickSearch() - invoking the session timeout process once the user logged in.
   */
  async populateUsernameAndQuickSearch(): Promise<any> {
    this.userClaims = await this._oktaAuth.getUser();
    if (this.userClaims) {
      if (localStorage.getItem('isToastrTokenTimeoutDisplayed')) {
        this.isToastrTokenTimeoutDisplayed = JSON.parse(
          localStorage.getItem('isToastrTokenTimeoutDisplayed')!
        );
      } else {
        this.isToastrTokenTimeoutDisplayed = false;
      }
      if (this.isToastrTokenTimeoutDisplayed !== true) {
        this.createSessionTimeoutWarning();
      }
      this.createSessionTimeout();
    }
  }

  /**
   *createSessionTimeout() - creating hte session start time from this method
   */
  createSessionTimeout(): any {
    const secondsToExpiration = this.getSecondsUntilAccessTokenExpires();
    this.clearSessionTimeout();
    this.sessionTimeout = setTimeout(() => {
      this.clearSessionTimeout();
      localStorage.setItem('isSessionExpired', 'true');
      this.addUserSuccess =
        'Your secure session is expired. Please login again.';
      this.showSuccess(this.successTpl);
      this.logout();
    }, secondsToExpiration * 1000);
  }

  /**
   *createSessionTimeoutWarning() - method will invoke 5min before the auto logout functionality.
   */
  createSessionTimeoutWarning(): any {
    const secondsToExpiration = this.getSecondsUntilAccessTokenExpires();
    const secondsBeforeExpirationToWarn = 300;
    this.clearSessionTimeoutWarning();
    this.sessionTimeoutWarning = setTimeout(() => {
      this.clearSessionTimeoutWarning();
      this.addUserError =
        'Session will expire in 5 minutes. Please complete items in progress to avoid losing unsaved changes.';
      this.showDanger(this.dangerTpl);
      localStorage.setItem('isToastrTokenTimeoutDisplayed', 'true');
    }, secondsToExpiration * 1000 - secondsBeforeExpirationToWarn * 1000);

    // Warning 1 minute before expiration
    const secondsBeforeExpirationToWarnOneMin = 60;
    this.sessionTimeoutWarningOneMin = setTimeout(() => {
      this.clearSessionTimeoutWarningOneMin();
      this.addUserError =
        'Session will expire in 1 minute. Please complete items in progress to avoid losing unsaved changes.';
      this.showDanger(this.dangerTpl);
      localStorage.setItem('isToastrTokenTimeoutDisplayed', 'true');
    }, secondsToExpiration * 1000 - secondsBeforeExpirationToWarnOneMin * 1000);
  }

  /**
   * clearSessionTimeoutWarning() - method will trigger the warning message.
   */
  clearSessionTimeoutWarning(): any {
    clearTimeout(this.sessionTimeoutWarning);
  }

  /**
   * clearSessionTimeoutWarningOneMin() - method will trigger the warning message.
   */
  clearSessionTimeoutWarningOneMin(): any {
    clearTimeout(this.sessionTimeoutWarningOneMin);
  }

  /**
   * clearSessionTimeout() - method will trigger the logged warning message.
   */

  clearSessionTimeout(): any {
    clearTimeout(this.sessionTimeout);
  }

  /**
   * showSuccess() - Displays a success toast notification with custom content and options.
   * @param successTpl - The template reference containing the toast's content.
   */
  showSuccess(successTpl: TemplateRef<any>): void {
    this.toastService.clear();
    this.toastService.show(successTpl, {
      classname: 'custom-toast',
      delay: 6000,
    });
  }

  /**
   * showDanger() - Displays a danger (error) toast message.
   * This method is called when there is an error in adding the user.
   * @param dangerTpl - The template reference for the danger message to display.
   */
  showDanger(dangerActionTpl: any): void {
    this.toastService.clear();
    this.toastService.show(dangerActionTpl, {
      classname: 'bg-danger text-light',
      delay: 6000,
    });
  }

  /**
   * logout() - Clears the user's cache, signs out from Okta, and removes all authentication tokens 
   */
  async logout(): Promise<any> {
    try {
      await this.headerService.clearCache().toPromise().catch(() => { });
      await this._oktaAuth.signOut();
    } catch (e) {
      // handle error if needed
    }
    localStorage.clear();
    this._oktaAuth.tokenManager.clear();
    localStorage.removeItem('access-token');
    localStorage.removeItem('okta-token-storage');
  }

  /**
   * callOktaLogoutSession() - method to kill the okta user session
   * @param url logout session okta url
   */
  callOktaLogoutSession(url: string): void {
    this.baseService.logout(url).pipe()
      .subscribe({
        next: () => {
          console.info('Logout successfully');
        },
        error: (error) => {
          console.error('Error in Logout URL:', error);
        }
      });
  }

  /**
   * redirectToDashboard() - Redirects the user to the appropriate dashboard based on their profile.
   * @param userProfile - The user's profile information.
   */
  redirectToDashboard(userProfile: any): void {
    const userTypeId = userProfile?.userTypeId;
    const roles = userProfile?.roles;

    // define these ONCE outside the switch
    const inputPath = localStorage.getItem('email-link');
    const targetPath = this.email_route.customer_portal;
    const requestPath = this.email_route.customer_request_path;
    const studioRequestPath = this.email_route.studio_request_path;

    const isValidCustomerPath = inputPath?.includes(targetPath) || inputPath?.includes(requestPath);
    const isValidStudioPath = inputPath?.includes(studioRequestPath);

    switch (userTypeId) {
      case 1:
        if (isValidCustomerPath) {
          this.router.navigate([inputPath]);
          localStorage.removeItem('email-link');
        } else {
          this.router.navigate(['/feature/customer-dashboard/overview']);
        }
        break;
      case 2:
        if (Array.isArray(roles) && roles.includes('A/R')) {
          this.router.navigate(['/feature/ar-dashboard/overview']);
        } else {
          if (isValidStudioPath) {
            this.router.navigate([inputPath]);
            localStorage.removeItem('email-link');
          } else {
            this.router.navigate(['/feature/studio-dashboard/Mydashboard']);
          }
        }
        break;
      default:
        this.router.navigate(['/homepage']);
        break;
    }
  }

}
